import React from 'react';

// Import helpers
import { mergeReactProps, combinedRef } from './helpers';

/* Inspired by https://www.radix-ui.com/docs/primitives/utilities/slot */
const Slot = React.forwardRef((props, forwardedRef) => {
	const { children, ...slotProps } = props;

	// Just one kid and a valid one
	React.Children.only(children);
	if (!React.isValidElement(children)) {
		return null;
	}
	return React.cloneElement(children, {
		...mergeReactProps(slotProps, children.props),
		ref: combinedRef([forwardedRef, children.ref])
	});
});

export default Slot;
